import { css } from "@emotion/react";

export const concept = css`
  padding-top: 80px;
  padding-bottom: 80px;
  @media (min-width: 600px) {
    padding-top: 128px;
    padding-bottom: 128px;
  }
`;

export const colorsArticle = css`
  margin-top: 80px;
`;

export const conceptTitle = css`
  color: var(--color-secondary);
  font-size: 24px;
  line-height: 41px;
  font-weight: 600;
`;

export const conceptDescription = css`
  margin-top: 24px;
  font-size: 18px;
  line-height: 28px;
  font-weight: 300;
`;

export const yuraiLogo = css`
  margin-top: 40px;
  text-align: center;
`;

export const feelList = css`
  margin-top: 24px;
  display: grid;
  gap: 32px;
  @media (min-width: 600px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 4px;
    padding: 0;
  }
`;

export const colorTitle = css`
  margin-top: 48px;
  font-size: 20px;
  font-weight: 600;
  line-height: 34px;
`;

export const subColorTitle = css`
  margin-top: 32px;
  font-size: 20px;
  font-weight: 600;
  line-height: 34px;
  @media (min-width: 600px) {
    margin-top: 48px;
  }
`;

export const mainColor = css`
  margin-top: 16px;
`;

export const subColors = css`
  margin-top: 16px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 32px 12px;
  @media (min-width: 600px) {
    gap: 48px 64px;
  }
`;

export const colorsContainer = css`
  max-width: 311px;
  margin-left: auto;
  margin-right: auto;
  @media (min-width: 600px) {
    max-width: 640px;
  }
`;
